import { AppEvent } from './app-event';

export const LOGOUT_EVENT = 'LOGOUT';

export class LogoutEvent extends AppEvent<null> {
  readonly type: string = LOGOUT_EVENT;
  readonly payload = null;
}
